// @flow

import React, { Component } from 'react';
import Alert from 'react-s-alert';
import Paper from 'material-ui/Paper';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import _ from 'lodash';
import $ from 'jquery';
import {saveAs} from 'file-saver';
import * as ExcelJs from 'exceljs/dist/es5/exceljs.browser';

import App from './App.jsx';

import Role from './roles.js';
import {takeDir, takeFilename, no_rclick, culti_regex, ms_regex, title_culti, hs_bool, isNumber} from './utils.js';
import {dbf_row_id} from './Shp.js';
import {empty_obs, empty_sen} from './types.js';
import get_order from './orden.js';

import type {T_ErrOk} from './types.js';
import type {T_ShpFile, T_TypeCol} from './Shp.js';

import {setHeaderExcel, setTitlesStyles} from './imgExcel.js';

const S = require('underscore.string');


type T_MenuCultiProps = {
  culti : string,
  cond  : boolean,
  elem  : string,        // *PATH* del elemento seleccionado, o '' si no hay ninguno abierto.
  app   : App
};



type T_MenuCultiState = {
  is_unpub  : boolean,
  has_sensor: boolean
};



function check_dbf_column(dts: {[string]: T_TypeCol}, col_name: string, must_type: string): boolean {
  const opt  = {timeout: 15000};
  
  if (! _.has(dts, col_name)) {
    Alert.error(`El dbf no tiene la columna ${col_name}.`, opt);
    
    return false;
  }
  
  if (dts[col_name].type !== must_type) {
    Alert.error(`La columna ${col_name} no es de tipo ${must_type}, sino ${dts[col_name].type}.`, opt);
    
    return false;
  }
  
  return true;
}




export default class MenuCulti extends Component<T_MenuCultiProps, T_MenuCultiState> {
  close      : () => void;
  change_item: (ev: SyntheticMouseEvent<*>, value: string) => void;
  
  
  
  constructor(props: T_MenuCultiProps) {
    super(props);
    
    this.state = {
      is_unpub: props.app.is_unpub(takeDir(props.culti)),
      has_sensor: props.app.has_sensor(props.culti)
    };
    
    this.close       = this.close.bind(this);
    this.change_item = this.change_item.bind(this);
  }
  
  
  
  toggle_publish(): void {
    const dir   = takeDir(this.props.culti),
          {app} = this.props,
          flag  = `${dir}/unpub.flag`,
          url   = `${app.remote}/toggle-file-flag/?path=${flag}&session_id=${app.session()}`;
    
    fetch(url).then(resp => resp.json()).then((response: T_ErrOk) => {
      if (response.error) {
        Alert.error('No se pudo cambiar la publicación de los mapas.');
      }
      else {
        app.toggle_publish(dir, () => {
          this.setState({
            is_unpub: this.props.app.is_unpub(takeDir(this.props.culti))
          });
        });
      }
      
      this.close();
    });
  }
  
  
  
  fix_name(path: string, key: string): string {
    const {app}   = this.props,
          shpFile = ((app.map_ui.map.Shp_List[path] ? app.map_ui.map.Shp_List[path].obj : null) : ?T_ShpFile);
    
    if (shpFile != null) {
      const convs = shpFile.convs != null ? shpFile.convs : null;
      
      if (convs != null) {
        return _.has(convs, key) ? convs[key] : key;
      }
      else {
        return key;
      }
    }
    else {
      return key;
    }
  }
  
  
  
  descargar_dbf_excel(): void {
    const {app}       = this.props,
          {culti}     = this.props,
          datos_culti = takeFilename(culti).match(culti_regex) ? app.map_ui.map.Shp_List[culti].obj.dbfRecords : [],
          dir         = takeDir(culti),
          ms_item     = app.get_ms_of(dir),
          ms_path     = ms_item != null ? ms_item.props.node.Path : '',
          datos_ms    = app.map_ui.map.Shp_List[ms_path] ? app.map_ui.map.Shp_List[ms_path].obj.dbfRecords : [],
          workbook    = new ExcelJs.Workbook(),
          title       = title_culti(culti);
    
    const setDatos_ms = () => {
      const worksheet   = workbook.addWorksheet('Datos MS'),
            styleMiddle = {alignment: {vertical: 'middle'}},
            title_ms    = title_culti(ms_path);
      
      setHeaderExcel(workbook, worksheet, title_ms, 'Datos del MS', 'MS');
      
      const keys   = _.keys(datos_ms[0]).map(key => this.fix_name(ms_path, key)),
            header = _.map(keys, (key) => {return {key, style: styleMiddle, width: 12};});
      
      worksheet.columns = header;
      
      const todo = [keys];
      
      datos_ms.forEach((dd) => {
        todo.push(_.values(dd));
      });
      
      worksheet.addRows(todo);
      
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 5) {
          row.height = 25;
          
          row.eachCell((cell, rowNumber) => {
            if (cell._column._number === 1) {
              cell.alignment = {vertical: 'middle', horizontal: 'center'};
            }
            
            const even = cell._row._number % 2 === 0;
            
            cell.fill = {
              type   : 'pattern',
              pattern: 'solid',
              fgColor: {argb: (even ? 'FFDEDEDE' : 'FFEFEFEF')},
              bgColor: {argb: (even ? 'FFDEDEDE' : 'FFEFEFEF')}
            };
          });
        }
      });
      
      setTitlesStyles(worksheet, 5, false);
    };
    
    const setDatos_culti = () => {
      const styleMiddle = {alignment: {vertical: 'middle'}},
            worksheet   = workbook.addWorksheet('Datos Cultivable');
      
      setHeaderExcel(workbook, worksheet, title, 'Datos del Cultivable', 'CULTI');
      
      worksheet.columns = [
        {key: 'id', style: styleMiddle},
        {key: 'nombre', style: styleMiddle, width: 15},
        {key: 'especie', style: styleMiddle, width: 15},
        {key: 'variedad', style: styleMiddle},
        {key: 'hectareas', style: styleMiddle, width: 15},
        {key: 'area', style: styleMiddle, width: 15},
        {key: 'perimetro', style: styleMiddle, width: 15}
      ];
      
      worksheet.addRow({
        id: 'ID',
        nombre: 'Nombre',
        especie: 'Especie',
        variedad: 'Variedad',
        hectareas: 'Hectáreas',
        area: 'Área (m2)',
        perimetro: 'Perímetro (m)'
      });
      
      setTitlesStyles(worksheet, 5, false);
      
      datos_culti.forEach((dd, kk) => {
        worksheet.addRow({
          id       : dd.ID,
          nombre   : dd.NOMBRE,
          especie  : dd.ESPECIE,
          variedad : dd.VARIEDAD,
          hectareas: dd.HECTAREAS,
          area     : dd.AREA,
          perimetro: dd.PERIMETRO
        });
        
        worksheet.getRow(kk + 6).height = 25;
        
        worksheet.getRow(kk + 6).eachCell((cell, cellNumber) => {
          if (cell._column._number === 1) {
            cell.alignment = {vertical: 'middle', horizontal: 'center'};
          }
          
          const even = cell._row._number % 2 === 0;
          
          cell.fill = {
            type   : 'pattern',
            pattern: 'solid',
            fgColor: {argb: (even ? 'FFDEDEDE' : 'FFEFEFEF')},
            bgColor: {argb: (even ? 'FFDEDEDE' : 'FFEFEFEF')}
          };
        });
      });
      
      if (datos_ms.length > 0) {
        setDatos_ms();
      }
    };
    
    if (datos_culti.length > 0) {
      setDatos_culti();
    }
    else {
      setDatos_ms();
    }
    
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(new Blob([buffer],{type:"application/octet-stream"}), `Base_Datos_${title.replace(/ /g, '_')}.xls`);
    });
    
    this.close();
  }
  
  
  
  descargar_carpeta(): void {
    const dir   = takeDir(this.props.culti),
          {app} = this.props;
    
    app.make_link(`${app.remote}/get-zip-folder/?agrosat_user=${hs_bool(app.agrosat_user)}&dir=${dir}&session_id=${app.session()}`);
    
    this.close();
  }
  
  
  
  descargar_kml(): void {
    const {app} = this.props;
    
    app.make_link(`${app.remote}/get-shp-as-kml/?path=${this.props.culti}&session_id=${app.session()}`);
    
    this.close();
  }
  
  
  
  descargar_puntos_muestreo(): void {
    const {app} = this.props;
    
    app.make_link(`${app.remote}/get-zip-pm/?path=${this.props.culti}&session_id=${app.session()}`);
    
    this.close();
  }
  
  
  
  add_new_obs(): void {
    const {app}  = this.props,
          center = app.map_ui.map.map.getCenter();
    
    app.setState({
      obs: empty_obs(takeDir(this.props.culti), app.state.user, center.lat(), center.lng())
    });
    
    this.close();
  }
  
  
  
  check_dbf(): void {
    if (_.has(this.props.app.map_ui.map.Shp_List, this.props.culti)) {
      const shp       = this.props.app.map_ui.map.Shp_List[this.props.culti].obj,
            ids       = shp.dbfRecords.map(rec => dbf_row_id(rec)),
            dts       = shp.dbf_column_types,
            good_id   = check_dbf_column(dts, 'ID'       , 'int'),
            good_name = check_dbf_column(dts, 'NOMBRE'   , 'string'),
            good_has  = check_dbf_column(dts, 'HECTAREAS', 'double'),
            good_area = check_dbf_column(dts, 'AREA'     , 'double'),
            opt       = {timeout: 15000};
      
      /* eslint-disable eqeqeq */
      
      const begin_1 = good_id && ids.length > 0 && ids[0] == 1;     // chequear también el "1".
      
      /* eslint-enable eqeqeq */
      
      let consec_id = false;
      
      if (_.every(ids, id => typeof id === 'number' || isNumber(id))) {   // _.min, _.max y _.range trabajan tambien con
        const min = _.min(ids),                                           // números codificados en strings.
              max = _.max(ids) + 1;
        
        if (_.isEqual(ids, _.range(min, max))) {
          consec_id = true;
        }
        else {
          Alert.error('La columna ID no tiene números consecutivos.', opt);
        }
      }
      
      if (! begin_1) {
        Alert.error(`La columna ID empieza en ${_.head(ids)}.`, opt);
      }
      
      if (good_id && good_name && good_has && good_area && consec_id && begin_1) {
        Alert.success('La base de datos del shape está OK.');
      }
    }
    
    this.close();
  }
  
  
  
  set_png_transparent(): void {
    const {app} = this.props,
          dir   = takeDir(this.props.culti),
          url   = `${app.remote}/set-png-transparent/?dir=${dir}&session_id=${app.session()}`;
    
    fetch(url).then(resp => resp.json()).then((result: T_ErrOk) => {
      if (result.error && typeof result.error === 'string') {
        Alert.error(result.error);
      }
      else if (result.ok && typeof result.ok === 'string') {
        Alert.success(result.ok);
      }
    });
    
    this.close();
  }
  
  
  
  close(): void {
    if (this.props.app.toolbar != null) {
      this.props.app.toolbar.setState({show_menu_culti: false});
    }
  }
  
  
  
  download_png_kmz(path: string): void {
    const {app} = this.props;
    
    app.make_link(`${app.remote}/get-png-as-kmz/?path=${path}&session_id=${app.session()}`);
    
    this.close();
  }
  
  
  
  change_item(ev: SyntheticMouseEvent<*>, value: string): void {
    if (ev.button !== 0) {
      return;
    }
    
    if (value === 'centrar') {
      if (this.props.app.toolbar != null) {
        this.props.app.toolbar.center_culti_both();
      }
    }
    else if (value === 'toggle_pub') {
      this.toggle_publish();
    }
    else if (value === 'desc_bd') {
      this.descargar_dbf_excel();
    }
    else if (value === 'desc_pm') {
      this.descargar_puntos_muestreo();
    }
    else if (value === 'desc_kml') {
      this.descargar_kml();
    }
    else if (value === 'desc_folder') {
      this.descargar_carpeta();
    }
    else if (value === 'menu_nota') {
      this.add_new_obs();
    }
    else if (value === 'menu_sensor') {
      this.set_sensor();
    }
    else if (value === 'menu_check') {
      this.check_dbf();
    }
    else if (value === 'menu_trans') {
      this.set_png_transparent();
    }
    else if (value === 'png_kmz') {
      this.download_png_kmz(this.props.elem);
    }
  }
  
  
  
  set_sensor(): void {
    const {app}        = this.props,
          {has_sensor} = this.state,
          center       = app.map_ui.map.map.getCenter()
    ;
    
    app.setState({ sen: empty_sen(takeDir(this.props.culti), center.lat(), center.lng()) },
    () => {
      if (! has_sensor) {
        console.log(app.state.sen);
        const {sen} = app.state;

        sen.file = `${sen.titulo.replace(/ /g, '_')}-${Date.now()}-${(Math.random() + '').slice(2)}.sensor`;
        sen.path = `${sen.dir}/${sen.file}`;

        $.ajax({
          type    : 'POST',
          url     : `${app.remote}/post-sensor/?session_id=${app.session()}&path=${sen.path}`,
          dataType: 'json',
          async   : true,
          data    : {sensor: JSON.stringify(sen)}
        }).done(async(res) => {
          await app.reload_dir(sen.dir, (resp) => {
            const item_sen = app.get_item_sen(res.sensor.path);

            if (item_sen !== null) {
              item_sen.open();
            }
          });

          if (res.error) {
            Alert.error('No se pudo generar el sensor.', {position: 'bottom-left'});                      
          } else {
            Alert.success('Sensor creado con éxito.', {position: 'bottom-left'});
          }
        })
      }
    }
    );
    
    this.close();
  }
  
  
  
  render() {
    if (_.has(this.props, 'cond') && ! this.props.cond) {
      return null;
    }
    
    const {app}   = this.props,
          m_style = {fontSize: 12, lineHeight: '30px'},
          lb_pub  = `${S.capitalize((! this.state.is_unpub ? 'no ' : ''))} publicar mapas`,
          left    = {style: {left: $('#bt_culti').position().left + 6}};
    
    const menu_pub = (app.agrosat_user ?
      <MenuItem style={m_style} value='toggle_pub' primaryText={lb_pub} onContextMenu={no_rclick} />
    :
      null
    );
    
    const fculti        = takeFilename(this.props.culti), 
          es_culti      = fculti.match(culti_regex),
          old_pm        = fculti.indexOf('ms_0000') === 0,
          es_ms         = fculti.match(ms_regex) && ! old_pm,
          es_pm         = fculti.toLowerCase().indexOf('pm') === 0 || old_pm,
          es_climasense = this.props.culti.toLowerCase().includes('climasense'),
          {has_sensor}  = this.state,
          {role}        = app.state.user,
          es_prod       = app.agrosat_user && (Role.es_produccion(role) || app.dev_mode),
          {elem}        = this.props,
          has_elem      = elem !== '',
          label         = es_culti ? 'Descargar excel del cultivable' : (es_ms ? 'Descargar excel del MS' : '');
    
    const menu_bd = ((es_culti || es_ms) &&
      <MenuItem style={m_style} value='desc_bd' primaryText={label} onContextMenu={no_rclick} />
    );
    
    const menu_pm = (es_pm &&
      <MenuItem style={m_style} value='desc_pm' primaryText='Descargar puntos de muestreo' onContextMenu={no_rclick} />
    );
    
    const menu_kml = ((es_pm || es_culti) &&
      <MenuItem style={m_style} value='desc_kml' primaryText='Descargar como KML' onContextMenu={no_rclick} />
    );
    
    const menu_nota = (es_culti &&
      <MenuItem style={m_style} value='menu_nota' primaryText='Agregar punto de observación' onContextMenu={no_rclick} />
    );
    
    const menu_sensor = ((es_culti && es_climasense && app.agrosat_user && (! has_sensor)) &&
      <MenuItem style={m_style} value='menu_sensor' primaryText='Agregar sensor Climasense' onContextMenu={no_rclick} />
    );
    
    const menu_check = ((es_prod && (es_culti || es_ms)) &&
      <MenuItem style={m_style} value='menu_check' primaryText='Diagnosticar' onContextMenu={no_rclick} />
    );
    
    const menu_trans = (es_prod &&
      <MenuItem style={m_style} value='menu_trans' primaryText='Quitar fondo a los mapas' onContextMenu={no_rclick} />
    );
    
    const menu_png = (has_elem &&
      <MenuItem
        style={m_style}
        value='png_kmz'
        primaryText={`Descargar ${get_order({Path: elem, File: takeFilename(elem), Type: 'png'}).label} como KMZ`}
        onContextMenu={no_rclick}
      />
    );
    
    return (
      <Paper className='float_menu' {...left}>
        <Menu onChange={this.change_item} desktop={true} style={{maxWidth: 230}}>
          <MenuItem style={m_style} value='centrar' primaryText='Centrar' onContextMenu={no_rclick} />
          {menu_pub}
          {menu_bd}
          {menu_pm}
          {menu_kml}
          {menu_png}
          <MenuItem style={m_style} value='desc_folder' primaryText='Descargar carpeta' onContextMenu={no_rclick} />
          {menu_nota}
          {menu_sensor}
          {menu_check}
          {menu_trans}
        </Menu>
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/MenuCulti.jsx